// extracted by mini-css-extract-plugin
export default {"root":"matches_information-module___root___daf65de2"};